import styled from "styled-components";

export const RdmContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  cursor: pointer;
  width: 100%;

  :hover {
    background: rgba(207, 248, 231, 0.6);
  }
  padding: 0.5rem 1rem;
  gap: 0.85rem;
`;

export const RdmHeader = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RdmDescription = styled.div`
  font-size: 0.85rem;
  color: #333;
`;

export const RdmGridContent = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  text-align: center;
`;

export const RdmGridItem = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding-top: 1rem;
  .rdm-item-header {
    font-size: 0.76rem;
    color: #7e858f;
  }
  .rdm-item-content {
    margin-top: 10px;
    font-size: 0.8rem;
    color: #232323;
    font-weight: bold;
  }

  .positives {
    color: rgb(0, 24, 92);
  }
  .negatives {
    color: rgb(255, 0, 0);
  }

  .percents {
    color: #118052;
    font-weight: 600;
  }
`;
